/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { View } from 'react-native';
import { Portal } from '@gorhom/portal';
import { usePortalUsageEnabled } from '../../hooks';

const PortalWrapperView = ({ children }: { children: React.ReactNode }) => {
  const { enabled: isPortalUsageEnabled } = usePortalUsageEnabled();

  if (isPortalUsageEnabled) {
    return <Portal hostName="flights-web-portal-host">{children}</Portal>;
  } else {
    return children;
  }
};

export default PortalWrapperView;
